'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

var _classConcat = require('../../utils/classConcat');

var _classConcat2 = _interopRequireDefault(_classConcat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var ariaExpanded = _ref.ariaExpanded,
      ariaControls = _ref.ariaControls,
      link = _ref.link,
      _ref$href = _ref.href,
      href = _ref$href === undefined ? link : _ref$href,
      onClick = _ref.onClick,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? (0, _idGen2.default)('button') : _ref$id,
      modifiers = _ref.modifiers,
      classNames = _ref.classNames,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? classNames : _ref$className,
      label = _ref.label,
      ariaLabel = _ref.ariaLabel,
      disabled = _ref.disabled,
      iconColor = _ref.iconColor,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      iconTitle = _ref.iconTitle,
      iconClassName = _ref.iconClassName,
      iconSpanDescription = _ref.iconSpanDescription,
      iconRight = _ref.iconRight,
      type = _ref.type,
      children = _ref.children,
      newTab = _ref.newTab;

  var iconOnly = !label && !children;
  var target = void 0;
  if (newTab) {
    target = '_blank';
  }
  var baseClass = 'luna-button';
  var buttonClasses = (0, _classnames2.default)([baseClass, (0, _classConcat2.default)(baseClass, modifiers), { iconOnly: iconOnly }, className]);

  var icon = iconName && _react2.default.createElement(_Icon2.default, {
    name: iconName,
    size: iconSize,
    title: iconTitle,
    className: iconClassName,
    ariaHidden: iconOnly.toString(),
    spanDescription: iconSpanDescription,
    color: iconColor
  });

  var buttonProps = {
    href: href,
    id: id,
    target: target,
    className: buttonClasses,
    'aria-label': ariaLabel,
    'aria-expanded': ariaExpanded,
    'aria-controls': ariaControls
  };

  return href ? _react2.default.createElement(
    'a',
    Object.assign({}, buttonProps, { role: 'button', onClick: onClick }),
    !iconRight && icon,
    _react2.default.createElement(
      'span',
      null,
      label
    ),
    children,
    iconRight && icon
  ) : _react2.default.createElement(
    'button',
    Object.assign({}, buttonProps, { type: type, disabled: disabled, onClick: onClick }),
    !iconRight && icon,
    _react2.default.createElement(
      'span',
      null,
      label
    ),
    children,
    iconRight && icon
  );
};

Button.propTypes = {
  modifiers: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  ariaLabel: _propTypes2.default.string,
  id: _propTypes2.default.string,
  iconColor: _propTypes2.default.string,
  iconName: _propTypes2.default.string,
  iconSize: _propTypes2.default.string,
  iconTitle: _propTypes2.default.string,
  iconRight: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
  className: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.object]),
  label: _propTypes2.default.string,
  link: _propTypes2.default.string,
  href: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

Button.defaultProps = {
  type: 'button'
};

exports.default = Button;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Button/Button.js